import { commonCoutries, commonICs } from 'redux/selectors/common'
import routeParams from 'helpers/routeParams'

const GET_COUNTRIES = 'dofe-bo/common/GET_COUNTRIES'
const GET_COUNTRIES_SUCCESS = 'dofe-bo/common/GET_COUNTRIES_SUCCESS'
const GET_COUNTRIES_FAIL = 'dofe-bo/common/GET_COUNTRIES_FAIL'

const CHECK_CAPTCHA = 'dofe-bo/common/CHECK_CAPTCHA'
const CHECK_CAPTCHA_SUCCESS = 'dofe-bo/common/CHECK_CAPTCHA_SUCCESS'
const CHECK_CAPTCHA_FAIL = 'dofe-bo/common/CHECK_CAPTCHA_FAIL'
const GET_REGIONS = 'dofe-bo/common/GET_REGIONS'
const GET_REGIONS_SUCCESS = 'dofe-bo/common/GET_REGIONS_SUCCESS'
const GET_REGIONS_FAIL = 'dofe-bo/common/GET_REGIONS_FAIL'
const LOADING_IMAGE = 'dofe-bo/common/LOADING_IMAGE'
const LOADING_IMAGE_SUCCESS = 'dofe-bo/common/LOADING_IMAGE_SUCCESS'
const LOADING_IMAGE_FAIL = 'dofe-bo/common/LOADING_IMAGE_FAIL'

const GET_VERSION = 'dofe-bo/common/GET_VERSION'
const GET_VERSION_SUCCESS = 'dofe-bo/common/GET_VERSION_SUCCESS'
const GET_VERSION_FAIL = 'dofe-bo/common/GET_VERSION_FAIL'

const GET_LOCALES = 'dofe-bo/common/GET_LOCALES'
const GET_LOCALES_SUCCESS = 'dofe-bo/common/GET_LOCALES_SUCCESS'
const GET_LOCALES_FAIL = 'dofe-bo/common/GET_LOCALES_FAIL'

const GET_PUBLIC_AWARD_UNITS = 'dofe-bo/common/GET_PUBLIC_AWARD_UNITS'
const GET_PUBLIC_AWARD_UNITS_SUCCESS =
  'dofe-bo/common/GET_PUBLIC_AWARD_UNITS_SUCCESS'
const GET_PUBLIC_AWARD_UNITS_FAIL = 'dofe-bo/common/GET_PUBLIC_AWARD_UNITS_FAIL'

const DOWNLOADING_IMAGE = 'dofe-bo/common/DOWNLOADING_IMAGE'

const CHECK_AUTH_CODE = 'dofe-bo/common/CHECK_AUTH_CODE'
const CHECK_AUTH_CODE_SUCCESS = 'dofe-bo/common/CHECK_AUTH_CODE_SUCCESS'
const CHECK_AUTH_CODE_FAIL = 'dofe-bo/common/CHECK_AUTH_CODE_FAIL'

const REFRESH_BLOB_ACCESS = 'dofe-bo/common/REFRESH_BLOB_ACCESS'
const REFRESH_BLOB_ACCESS_SUCCESS = 'dofe-bo/common/REFRESH_BLOB_ACCESS_SUCCESS'
const REFRESH_BLOB_ACCESS_FAIL = 'dofe-bo/common/REFRESH_BLOB_ACCESS_FAIL'

const initialState = {
  countries: {
    loading: false,
    loaded: false,
    list: [],
    listWithStructure: []
  },
  ics: {
    loading: false,
    loaded: false,
    list: []
  },
  regions: {
    loading: false,
    loaded: false,
    list: []
  },
  version: {
    loading: false,
    loaded: false,
    detail: {}
  },
  image: {
    loading: false,
    loaded: false
  },
  locales: {
    list: [],
    loading: false,
    loaded: false,
    lastFetchedFor: null
  },
  awardUnits: {
    list: [],
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        ...state,
        countries: {
          ...state.countries,
          loading: true
        }
      }
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          list: commonCoutries(action.result),
          listWithStructure: action.result,
          loading: false,
          loaded: true
        },
        ics: {
          list: commonICs(action.result),
          loading: false,
          loaded: true
        }
      }
    case GET_COUNTRIES_FAIL:
      return {
        ...state,
        countries: {
          error: action.error,
          loading: false
        },
        ics: {
          error: action.error,
          loading: false
        }
      }

    case LOADING_IMAGE:
      return {
        ...state,
        image: {
          loading: true
        }
      }
    case LOADING_IMAGE_SUCCESS:
      return {
        ...state,
        image: {
          loading: false,
          loaded: true
        }
      }
    case LOADING_IMAGE_FAIL:
      return {
        ...state,
        image: {
          error: action.error,
          loading: false
        }
      }
    case DOWNLOADING_IMAGE:
      return {
        ...state,
        image: {
          loading: action.bool
        }
      }
    case GET_REGIONS:
      return {
        ...state,
        regions: {
          loading: false,
          loaded: false
        }
      }
    case GET_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          list: commonCoutries(action.result),
          loading: false,
          loaded: true
        }
      }
    case GET_REGIONS_FAIL:
      return {
        ...state,
        regions: {
          error: action.error,
          loading: false
        }
      }
    case GET_VERSION:
      return {
        ...state,
        version: {
          loading: false,
          loaded: false
        }
      }
    case GET_VERSION_SUCCESS:
      return {
        ...state,
        version: {
          detail: action.result,
          loading: false,
          loaded: true
        }
      }
    case GET_VERSION_FAIL:
      return {
        ...state,
        version: {
          error: action.error,
          loading: false
        }
      }
    case GET_LOCALES:
      return {
        ...state,
        locales: {
          ...state.locales,
          loading: true,
          loaded: false
        }
      }
    case GET_LOCALES_SUCCESS:
      return {
        ...state,
        locales: {
          list: action.meta.isTopUser
            ? action.result
            : action.result.list,
          loading: false,
          loaded: true,
          lastFetchedFor: action.meta.isTopUser
        }
      }
    case GET_LOCALES_FAIL:
      return {
        ...state,
        locales: {
          ...state.locales,
          error: action.error,
          loading: false
        }
      }
    case GET_PUBLIC_AWARD_UNITS:
      return {
        ...state,
        awardUnits: {
          ...state.awardUnits,
          loading: false,
          loaded: false
        }
      }
    case GET_PUBLIC_AWARD_UNITS_SUCCESS:
      return {
        ...state,
        awardUnits: {
          list: action.result,
          loading: false,
          loaded: true
        }
      }
    case GET_PUBLIC_AWARD_UNITS_FAIL:
      return {
        ...state,
        awardUnits: {
          ...state.awardUnits,
          error: action.error,
          loading: false
        }
      }
    default:
      return state
  }
}

export function getCountriesWithStructure(baseFilter) {
  return {
    types: [GET_COUNTRIES, GET_COUNTRIES_SUCCESS, GET_COUNTRIES_FAIL],
    promise: client =>
      client.get(
        `api/countries?with=ORG_STRUCTURE_INFO${routeParams({}, baseFilter)}`
      )
  }
}

export function getPublicCountries() {
  return {
    types: [GET_COUNTRIES, GET_COUNTRIES_SUCCESS, GET_COUNTRIES_FAIL],
    promise: client => client.get('api/registration/countries')
  }
}

export function checkCaptcha(response) {
  return {
    types: [CHECK_CAPTCHA, CHECK_CAPTCHA_SUCCESS, CHECK_CAPTCHA_FAIL],
    promise: client =>
      client.post('https://www.google.com/recaptcha/api/siteverify', {
        external: true,
        data: {
          response
        }
      })
  }
}

export function getRegions() {
  return {
    types: [GET_REGIONS, GET_REGIONS_SUCCESS, GET_REGIONS_FAIL],
    promise: client => client.get('api/regions')
  }
}

export function uploadImage(data) {
  return {
    types: [LOADING_IMAGE, LOADING_IMAGE_SUCCESS, LOADING_IMAGE_FAIL],
    promise: client =>
      client.put('api/blobs', {
        data,
        formData: true
      })
  }
}

export function getVersion() {
  return {
    types: [GET_VERSION, GET_VERSION_SUCCESS, GET_VERSION_FAIL],
    promise: client =>
      client.get('api/version', {
        removeToken: true
      })
  }
}

export function getLocales(isTopUser) {
  const endpoint = isTopUser
    ? 'api/translation-locales-system'
    : 'apiv2/registration/locale/list'

  const method = isTopUser ? 'get' : 'post'

  return {
    types: [GET_LOCALES, GET_LOCALES_SUCCESS, GET_LOCALES_FAIL],
    promise: client => client[method](endpoint),
    meta: { isTopUser }
  }
}

export function getPublicAwardUnits({ countryId } = {}) {
  return {
    types: [
      GET_PUBLIC_AWARD_UNITS,
      GET_PUBLIC_AWARD_UNITS_SUCCESS,
      GET_PUBLIC_AWARD_UNITS_FAIL
    ],
    promise: client =>
      client.get(
        `api/participant-registrations/award-units?countryId=${countryId}`,
        {
          removeToken: true
        }
      )
  }
}

export function loadingImage(bool) {
  return {
    type: DOWNLOADING_IMAGE,
    bool
  }
}

export function isValidAuthCode(authCode) {
  return {
    types: [CHECK_AUTH_CODE, CHECK_AUTH_CODE_SUCCESS, CHECK_AUTH_CODE_FAIL],
    promise: client =>
      client.get(
        `api/authorization-code/check-validity?authorizationCode=${authCode}`,
        {
          removeToken: true
        }
      )
  }
}

export function refreshBlobAccess(authCode) {
  const data = { authorizationCode: authCode }
  return {
    types: [REFRESH_BLOB_ACCESS, REFRESH_BLOB_ACCESS_SUCCESS, REFRESH_BLOB_ACCESS_FAIL],
    promise: client => client.post(`api/authorization-code/refresh-blob-access`, { data } )
  }
}
